import { useEffect, useState } from 'react'
import { apiGet } from '../../../generic/Api_Functions'
import { Stack, TextField } from '@mui/material'
import SmartSelect from '../../../generic/smartSelect/SmartSelect'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'

const LoginDialog = ({ request, setRequest, AlertElement }) => {
  const [devices, setDevices] = useState(null)
  const { t_ } = useSmartTranslation()

  useEffect(() => {
    const getDevices = async () => {
      const data = await apiGet('deviceIdCodeName')
      setDevices(data)
    }

    getDevices()
  }, [])

  return (
    <Stack spacing={2} sx={{ width: '100%', marginTop: '1rem' }}>
      {AlertElement}
      <TextField
        required
        label={t_('Worker code')}
        value={request?.workerCode || ''}
        onChange={(e) => setRequest({ ...request, workerCode: e.target.value })}
        fullWidth
      />
      <SmartSelect
        label={t_('Select assets')}
        multiple
        value={request?.deviceList?.map(d => d.name) || []}
        selectableOptions={devices?.map(d => d.name) || []}
        onChange={(newValues) => {
          const selectedDevices = devices?.filter(d => newValues.includes(d.name))
          setRequest({ ...request, deviceList: selectedDevices })
        }}
      />
    </Stack>
  )
}

export default LoginDialog
